// extracted by mini-css-extract-plugin
export var md = "_1u-4";
export var semantic = "_1u-5";
export var sm = "_1u-3";
export var text = "_1u-6";
export var toggleInput = "_1u-0";
export var toggleSwitch = "_1u-1";
export var xs = "_1u-2";